import api from '../instance/axios_instance.ts';
import { CreditInterface } from '../interface/creditInterface.ts';

const CreateCredit = async (data: CreditInterface): Promise<CreditInterface> => {
    try {
        const response = await api.post<CreditInterface>('/credit', data);
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }
};

export default CreateCredit;